import React, { useRef } from 'react';
import { Stage, Layer, Line } from 'react-konva';
import CanvasElement from './CanvasElement';
import { GRID_SIZE, CANVAS_WIDTH, CANVAS_HEIGHT, snapToGrid, createDefaultElement } from './elementDefaults';

const FloorPlanCanvas = ({ elements, selectedId, onSelect, onChange, onAdd, nextTableNo }) => {
  const stageRef = useRef();

  const handleDrop = (e) => {
    e.preventDefault();
    const stageBox = stageRef.current.container().getBoundingClientRect();
    const x = snapToGrid(e.clientX - stageBox.left);
    const y = snapToGrid(e.clientY - stageBox.top);

    const data = e.dataTransfer.getData('application/json');
    if (!data) return;

    try {
      const { category, subType } = JSON.parse(data);
      const newEl = createDefaultElement(category, subType, x, y, nextTableNo);
      if (newEl) onAdd(newEl);
    } catch (err) {
      console.error('Drop error:', err);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleStageClick = (e) => {
    if (e.target === e.target.getStage()) {
      onSelect(null);
    }
  };

  // Draw grid lines
  const gridLines = [];
  for (let i = 0; i <= CANVAS_WIDTH; i += GRID_SIZE) {
    gridLines.push(
      <Line key={`v-${i}`} points={[i, 0, i, CANVAS_HEIGHT]} stroke="#eee" strokeWidth={0.5} />
    );
  }
  for (let j = 0; j <= CANVAS_HEIGHT; j += GRID_SIZE) {
    gridLines.push(
      <Line key={`h-${j}`} points={[0, j, CANVAS_WIDTH, j]} stroke="#eee" strokeWidth={0.5} />
    );
  }

  // Sort: zones first (background), then fixed, then tables (foreground)
  const sortOrder = { zone: 0, fixed: 1, table: 2 };
  const sortedElements = [...elements].sort((a, b) => (sortOrder[a.type] || 0) - (sortOrder[b.type] || 0));

  return (
    <div
      role="application"
      aria-label="Floor plan canvas — drag elements from toolbar to add them"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      style={{ border: '1px solid #ccc', borderRadius: 4, overflow: 'hidden', background: '#fafafa' }}
    >
      <Stage
        ref={stageRef}
        width={CANVAS_WIDTH}
        height={CANVAS_HEIGHT}
        onClick={handleStageClick}
        onTap={handleStageClick}
      >
        <Layer>
          {gridLines}
          {sortedElements.map((el) => (
            <CanvasElement
              key={el.id}
              element={el}
              isSelected={el.id === selectedId}
              onSelect={(element) => onSelect(element?.id || null)}
              onChange={onChange}
            />
          ))}
        </Layer>
      </Stage>
    </div>
  );
};

export default FloorPlanCanvas;
